<template>
    <Form :rules="innerRules" populateType="chain" :value="list">
        <field-group
            v-for="(item, index) in list"
            :key="index"
            :model="item"
            class="meter-item"
        >
            <Row :gutter="20">
                <Col span="10">
                    <!-- 选择表 -->
                    <FormItem class="meter-field" prop="deviceMeterType">
                        <Select v-model="item.deviceMeterType" transfer>
                            <Option
                                v-for="v in meterList"
                                :key="v.id"
                                :value="v.text"
                                :disabled="v.disabled"
                            >
                                {{ v.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="10">
                    <!-- 设置单价 -->
                    <FormItem class="meter-field" prop="price">
                        <input-number
                            v-model="item.price"
                            :min="0"
                            :allowNegative="false"
                        >
                            <template #append>
                                {{
                                    item.deviceMeterType
                                        ? hashMap[item.deviceMeterType]
                                        : hashMap['电表']
                                }}
                            </template>
                        </input-number>
                    </FormItem>
                </Col>
                <Col span="4">
                    <span class="meter-cut" @click="cut(index)"> - </span>
                </Col>
            </Row>
        </field-group>
        <div style="line-height: 30px">
            <div class="meter-add" @click="add">
                <span class="meter-add-plus">+</span>添加水电表
            </div>
        </div>
    </Form>
</template>
<script>
import { Field } from 'ivux'

// 房间配置
export default {
    name: 'addMeter',

    mixins: [Field],

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        meterTypeDict: {
            type: Object,
            default: () => {},
        },
        populateType: {
            type: String,
            default: 'through',
        },
    },

    data() {
        return {
            list: [],
            hashMap: {
                电表: '元/度',
                水表: '元/吨',
                热水表: '元/吨',
            },
        }
    },

    watch: {
        value(val) {
            this.setData(val)
        },
        list: {
            handler(val) {
                this.$emit('input', val)
            },
            deep: true,
        },
    },

    computed: {
        innerRules() {
            return {
                deviceMeterType: [{ required: true, message: '表类型必填' }],
                price: [{ required: true, message: '单价必填' }],
            }
        },

        meterList() {
            const meterList = this.meterTypeDict.toList()
            this.list.forEach((v) => {
                const meter = meterList.find(
                    (m) => m.text === v.deviceMeterType
                )
                if (meter) {
                    meter.disabled = true
                }
            })
            return meterList
        },
    },

    created() {
        this.setData(this.value)
    },

    methods: {
        // 初始化数据
        setData(list) {
            this.list = [...list]
        },
        add() {
            this.list.push(this.createItem())
        },
        cut(i) {
            this.list.splice(i, 1)
        },
        createItem() {
            return {
                deviceMeterType: '',
                price: 0,
            }
        },
    },
}
</script>
<style lang="less" scoped>
.meter {
    overflow: hidden;
    &-item {
        position: relative;
        margin-bottom: 11px;
    }

    &-field {
        flex-basis: 20px;
    }
    &-cut {
        display: inline-block;
        cursor: pointer;
        line-height: 0;
        font-size: 18px;
        padding: 14px 10px;
        display: inline-block;
        border: 1px solid #ccc;
        border-radius: 4px;
        background: #fff;
    }

    &-add {
        display: inline-block;
        cursor: pointer;
        line-height: 14px;

        &-plus {
            line-height: 12px;
            padding: 0 2px;
            margin-right: 2px;
            display: inline-block;
            border: 1px solid #ccc;
            border-radius: 4px;
            background: #fff;
        }
    }
}
</style>
